/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * The styled components fro BreadCrumbs
 *
 * @author Maxim Fedorov
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.1.0
 */

import styled from 'styled-components';

import { ImgStyled } from '../../../../components/common/Block/Img';
import { colors, fonts } from '../../../../theme';

export const BreadCrumbsContainerStyled = styled.div`
    display: flex;
    align-items: center;
    margin-right: 10px;
    height: 16px;
    ${fonts.textSmall};

    ${ImgStyled} {
        margin-right: 10px;
    }

    .bread-crumbs__link {
        color: ${colors.textColorOpacity};

        &:hover {
            text-decoration: underline;
        }
    }

    &:last-child {
        color: ${colors.textColor};

        .bread-crumbs__link {
            color: ${colors.textColor};
        }
    }

`;

export const BreadCrumbsLayoutStyled = styled.div`
    display: flex;
    margin-bottom: 12px;
`;
